import React, { useEffect, useState } from 'react';
import apiService from '../../../services/apiService';
import Loader from '../../layouts/loader';
import CustomToast from '../../Toast';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import CourseCompletedModal from '../modal/courseCompletedModal';

const Reading = ({ moduleContent, updateLmsModule, course, lastModuleCompleted }) => {
  const [completed, setCompleted] = useState(false);
  const [feedBack,setFeedBack] = useState("")
  const [disableInput, setDisableInput] = useState(false)
  const [loader, setLoader] = useState(false);
  const [showCourseModal, setShowCourseModal] = useState(false);
  const { i18n } = useTranslation();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const currentLang = course?.lang;

  console.log("course:", course);

  const getLangCode = (lang) => {
    switch (lang) {
      case 'English':
        return 'en'; 
      case 'Hindi':
        return 'hi';
      case 'Marathi':
        return 'mar';
      default:
        return 'en';
    }
  };

  const langId = getLangCode(currentLang);
  const tForLang = i18n.getFixedT(langId);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [])

  useEffect(()=> {
    if(moduleContent?.content_type == "feedback") {
      fetchFeedbackData()
    }
  }, [moduleContent])

  const fetchFeedbackData = async()=> {
    setLoader(true)
      const result = await apiService.getLmsv1(`/getUserFeedback?course_id=${moduleContent?.course_id}&user_id=${moduleContent?.user_id}&org_id=${moduleContent?.org_id}`)
      if(result && result?.data && result?.data?.feedback) {
        setFeedBack(result?.data?.feedback)
        setDisableInput(true)
        setLoader(false)
      } else {
        setFeedBack('')
        setLoader(false)
      }
  }

  const handleMarkAsCompleted = async() => {
    if(moduleContent?.content_type == "feedback"){
      if(!feedBack) {
        CustomToast.info(tForLang('toast_messages_add_feedback'));
      } else {
        let datas= {
          "course_id": moduleContent?.course_id,
          "user_id": moduleContent?.user_id,
          "org_id": moduleContent?.org_id,
          "feedback": feedBack
        }
        await apiService.postLms('saveUserFeedback',datas ).then((data)=>{
          updateLmsModule().then((data) => {
    
          })
        })
      }
    } else{
    updateLmsModule().then((data) => {

      console.log("Module updated successfully", data);

    })}

    if(moduleContent?.content_type === "last_module") {
      setShowCourseModal(true);
      // Don't navigate immediately, let the modal handle it
    } 
    setCompleted(true);
  };
  

  return (
    <div>
      <div className='reading' dangerouslySetInnerHTML={{ __html: moduleContent?.content }} />
      {loader ? <Loader /> : moduleContent?.content_type == "feedback"  ? <input
        type="text"
        className="form-control"
        placeholder={t('course_modules_feedback')}
        value={feedBack}
        name="FeedBack"
        onChange={(e) => setFeedBack(e.target.value)}
        disabled= {disableInput}
        required
      /> : null}
      <br />
      <div className='text-end border-top pt-4 mt-4'>
        {(course?.course_status === "inprogress" || course?.course_status === "notstarted") && (
          <button onClick={handleMarkAsCompleted} className='btn btn-md btn-primary rounded-pill'>{moduleContent?.content_type === "copyright" ? tForLang('course_modules_accept') : moduleContent?.content_type === "last_module" ? tForLang('course_modules_complete_course') : moduleContent?.content_type === "feedback" ? tForLang('course_modules_submit') : tForLang('course_modules_next')}</button>
        )}

        {course?.course_status === "completed" && (
          <button onClick={handleMarkAsCompleted} className='btn btn-md btn-primary rounded-pill'>{tForLang('course_modules_next')}</button>
        )}

         {moduleContent?.content_type == "last_module" && (showCourseModal || (course?.course_status === "completed" && lastModuleCompleted)) && (
          <CourseCompletedModal
           isOpen={showCourseModal || lastModuleCompleted}
           courseId={course?.course_id}
           courseLang={course?.lang}
           onClose={() => {
             setShowCourseModal(false);
             navigate('/micro_module');
           }}
           onComplete={() => {
             setShowCourseModal(false);
             navigate('/micro_module');
           }}
          />
        )}

      </div>
    </div>
  );
};

export default Reading;